import {UtilityService} from "../app/utils/UtilityService";
export const environment = {
  production: true,
  api: UtilityService.getUrlService(),
  //api: "http://services.api.misteryfood.com"
  //api: "http://services-qas.api.misteryfood.com";
  apiRest : 'api/rest/',
  publicRest : 'public/rest/',
  endpoints: UtilityService.getEndpoints(),
  googleClientId: "388863370890-finfq6tmg4sem1cuissdf3ghh4741bhi.apps.googleusercontent.com",
  googleRedirectUri: 'http://localhost:4200/oauth2/callback', // registra este URI en Google Cloud
};
